import { render } from "./form-textarea.vue?vue&type=template&id=d43124d2"
import script from "./form-textarea.vue?vue&type=script&lang=js"
export * from "./form-textarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__